/**
 * Groups-related GraphQL queries
 * Group management, creation, and patient assignment
 */

export const GROUPS_QUERIES = {
  // Group queries
  GET_GROUP_DETAILS: `
    query GetGroupDetails($where: pep_vw_group_details_bool_exp) {
      pep_vw_group_details(where: $where) {
        group_id
        group_name
        group_type
        group_type_id
        clinic_name
        es_id
        es_name
        number_of_patients
        updated_time_utc
        patient_clinic_timezone
        group_filters
        is_archive
      }
    }
  `,

  // Get all active groups
  GET_ALL_ACTIVE_GROUPS: `
    query GetAllActiveGroups {
      pep_vw_group_details(where: {is_archive: {_eq: false}}, order_by: {group_id: desc}) {
        group_id
        group_name
        es_id
        es_name
        group_type
        group_type_id
        clinic_id
        clinic_name
        updated_time_utc
        patient_clinic_timezone
        is_archive
        number_of_patients
      }
    }
  `,

  // Get archived groups
  GET_ARCHIVED_GROUPS: `
    query GetArchivedGroups {
      pep_vw_group_details(where: {is_archive: {_eq: true}}) {
        group_id
        group_name
        es_id
        es_name
        group_type
        group_type_id
        clinic_id
        clinic_name
        updated_time_utc
        patient_clinic_timezone
        is_archive
      }
    }
  `,

  // Group type queries
  GET_GROUP_TYPES: `
    query GetGroupTypes {
      pep_group_type_mapping(order_by: {id: asc}) {
        id
        group_type
      }
    }
  `,

  // Patient list by group
  GET_GROUP_PATIENT_LIST: `
    query GetGroupPatientList($groupId: Int!) {
      pep_vw_group_patient_list(where: {group_id: {_eq: $groupId}}) {
        assigned_clinic_id
        patient_list
      }
    }
  `,

  // Check group name exists
  CHECK_GROUP_NAME: `
    query CheckGroupName($groupName: String!) {
      pep_vw_group_details(where: {group_name: {_eq: $groupName}, is_archive: {_eq: false}}) {
        group_id
        group_name
      }
    }
  `,

  // PEP Group Details Query (from GRAPHQL_QUERIES)
  PEP_GROUP_DETAILS: `
    query MyQuery {
      pep_vw_group_details(where: {is_archive: {_eq: false}}, order_by: {group_id: desc}) {
        group_id
        group_name
        es_id
        es_name
        group_type
        group_type_id
        clinic_id
        clinic_name
        updated_time_utc
        patient_clinic_timezone
        is_archive
      }
    }
  `,

  // Dropdown Group Type (from GRAPHQL_QUERIES)
  DROPDOWN_GROUP_TYPE: `
    query MyQuery {
      pep_group_type_mapping(order_by: {id: asc}) {
        id
        group_type
      }
    }
  `,

  // Patient Group Audit Log
  GET_PATIENT_GROUP_AUDIT_LOG: `
    query GetPatientGroupAuditLog($patientGroupId: Int!) {
      pep_patient_group_audit_log(where: {patient_group_id: {_eq: $patientGroupId}}, order_by: {action_datetime: desc}) {
        pep_patient_group_audit_log_id
        patient_group_id
        action_type
        action_datetime
        metadata
      }
      pep_patient_group_audit_log_aggregate(where: {patient_group_id: {_eq: $patientGroupId}}) {
        aggregate {
          count
        }
      }
    }
  `,

  // Group Type List (from GRAPHQL_QUERIES)
  GROUP_TYPE_LIST: `
    query MyQuery {
      pep_group_type_mapping(order_by: {id: asc}) {
        id
        group_type
      }
    }
  `,

  // List Groups (from GRAPHQL_QUERIES)
  LIST_GROUPS: `
    query MyQuery {
      pep_vw_group_details(where: {is_archive: {_eq: false}}, order_by: {group_id: desc}) {
        group_id
        group_name
        es_id
        es_name
        group_type
        group_type_id
        clinic_id
        clinic_name
        updated_time_utc
        patient_clinic_timezone
        is_archive
      }
    }
  `,

  // Group patient list for email (from GRAPHQL_QUERIES)
  GROUP_PATIENT_LIST_FOR_EMAIL: `
    query MyQuery($groupId: Int!) {
      pep_vw_patient_list(where: {group_id: {_eq: $groupId}}) {
        patient_clinic_data_id
        first_name
        last_name
        email
        mobile_phone_number
        home_phone_number
      }
    }
  `,

  // Group details (from GRAPHQL_QUERIES)
  GROUP_DETAILS: `
    query MyQuery($groupId: Int!) {
      pep_vw_group_details(where: {group_id: {_eq: $groupId}}) {
        group_id
        group_name
        es_id
        es_name
        group_type
        group_type_id
        clinic_id
        clinic_name
        updated_time_utc
        patient_clinic_timezone
        is_archive
      }
    }
  `,

  // Archived Group List (from GRAPHQL_QUERIES)
  ARCHIVED_GROUP_LIST: `
    query MyQuery {
      pep_vw_group_details(where: {is_archive: {_eq: true}}, order_by: {group_id: desc}) {
        group_id
        group_name
        es_id
        es_name
        group_type
        group_type_id
        clinic_id
        clinic_name
        updated_time_utc
        patient_clinic_timezone
        is_archive
      }
    }
  `,


  // Get patient group dashboard data
  GET_PATIENT_GROUP_DASHBOARD: `
    query MyQuery {
      pep_vw_patient_group_dashboard(where: {is_archived: {_eq: false}}) {
        group_filters
        group_name
        is_archived
        patient_count
        patient_group_id
      }
    }
  `
};